import { BarceloComponent } from "components-utils";

const ListingComponents = {
  collectionList: BarceloComponent({
    selector: ".c-collection-list",
    path: "barcelo/listing/collection-list/js/collection-list",
  }),

  feedEntries: BarceloComponent({
    selector: ".c-feed-entries",
    path: "barcelo/listing/feed-entries/js/c-feed-entries",
    ignoreViewport: true,
    mobileDelay: 18000,
  }),

  cardHotelList: BarceloComponent({
    selector: ".c-card-hotel-list__content, .c-card-hotel-list",
    path: "barcelo/listing/card-hotel-list/js/card-hotel-list",
    enableObserver: true,
    ignoreViewport: true,
  }),

  collectionsListing: BarceloComponent({
    selector: ".JS-offers-collections",
    path: "barcelo/listing/offer-collection-list/js/c-offer-collection-list",
  }),

  offerDestination: BarceloComponent({
    selector: ".JS-offers-destination",
    path: "barcelo/listing/offers-destination/js/c-offers-destination",
  }),

  offer: BarceloComponent({
    selector: ".c-offer",
    path: "barcelo/listing/offer/js/offer",
  }),

  promoList: BarceloComponent({
    selector: ".c-promo-list",
    path: "barcelo/listing/promo-list/js/promo-list",
  }),

  swiperCollectionList: BarceloComponent({
    selector: ".JS-collection-link",
    path: "barcelo/listing/swipper-collection-list/js/swipper-collection-list",
  }),

  campaignList: BarceloComponent({
    selector: ".campaign-list",
    path: "barcelo/listing/campaign-list/js/c-campaign-list",
  }),
  uspCampaignHotelList: BarceloComponent({
    selector: ".usp-campaign-hotel-list-wrapper-js",
    path: "barcelo/listing/uspCampaignHotelList/js/uspCampaignHotelList",
  }),

  valueAdsList: BarceloComponent({
    selector: ".valueAdsList",
    path: "barcelo/listing/value-ads-list/js/value-ads-list",
  }),

  destinationsList: BarceloComponent({
    selector: ".destinations-list.dynamicLoading",
    path: "barcelo/listing/destinations-list/js/destinations-list",
  }),
};

export default ListingComponents;
